/**
 * Tile — colored KPI tile inside a SectionPanel grid.
 * tone controls the background; optional progress bar under the value.
 */
export default function Tile({
  label,
  value,
  sub,
  tone = "neutral", // neutral | critical | success | warning
  valueColor,
  progress, // 0-100 optional
  progressColor = "var(--rust-600)",
  onClick,
  testid,
}) {
  return (
    <div
      className={`ciso-tile ciso-tile--${tone}`}
      data-testid={testid}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div
        className="text-[11px] font-bold ciso-cap"
        style={{ color: "var(--text-muted)" }}
      >
        {label}
      </div>
      <div
        className="ciso-num"
        style={{
          fontSize: 27,
          fontWeight: 600,
          letterSpacing: "-0.025em",
          lineHeight: 1,
          color: valueColor || "var(--ink)",
          marginTop: 9,
        }}
      >
        {value}
      </div>
      {progress != null ? (
        <span
          style={{
            display: "block",
            height: 6,
            borderRadius: 999,
            background: "var(--slate-200)",
            overflow: "hidden",
            marginTop: 12,
          }}
        >
          <span
            style={{
              display: "block",
              height: "100%",
              width: `${Math.min(100, progress)}%`,
              background: progressColor,
              borderRadius: 999,
            }}
          />
        </span>
      ) : (
        sub && (
          <div className="text-[11.5px]" style={{ color: "var(--text-muted)", marginTop: 8 }}>
            {sub}
          </div>
        )
      )}
    </div>
  );
}
